<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<template>
  <div class="mobile-subsidebar">
    <div class="inner">
      <div class="sidebar-title">
        <h3>{{ t('sidebar-operation') }}</h3>
      </div>

      <ul class="submenu" data-simplebar>
        <li>
          <RouterLink :to="{ name: 'operation-kv' }">
            <i class="lnir lnir-key-alt" aria-hidden="true"></i>
            {{ t('sidebar-operation-kv') }}
          </RouterLink>
        </li>
        <li>
          <RouterLink :to="{ name: 'operation-push' }">
            <i class="fas fa-paper-plane" aria-hidden="true"></i>
            {{ t('sidebar-operation-push') }}
          </RouterLink>
        </li>
        <li>
          <RouterLink :to="{ name: 'operation-splash' }">
            <i class="iconify" data-icon="feather:edit-2" aria-hidden="true"></i>
            {{ t('sidebar-operation-app-splash-screen') }}
          </RouterLink>
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss">
@import '../../scss/abstracts/_variables.scss';
@import '../../scss/layout/_sidebar-mobile.scss';
</style>
